var _ = require('underscore');
var TableView = require('./../widget/brec-table/table-view/TableView');
var payableBillsListTemplate = require('./payableBillsListTemplate.hbs');
var PayableBillsItemView = require('./PayableBillsItemView');
var SecureMessageDataBehavior = require('./../secure-message/SecureMessageDataBehavior');
var messageService = require('./../secure-message/messageService');
var partialListUtils = require('./../utils/partialListUtils');
var secureMessageCollection = require('./../secure-message/secureMessageCollection');

/**
 * Payable Bills List on Make Payment
 *
 * @class PayableBillsListView
 */
module.exports = TableView.extend({
  id: 'payable-bills-table',
  template: payableBillsListTemplate,
  itemContainer: 'payable-bill-item',
  itemView: PayableBillsItemView,
  modelName: 'billMessageModel',
  __itemContext: function() {
    var itemContext = TableView.prototype.__itemContext.apply(this);
    itemContext.paymentDetailsFormModel = this.model;
    return itemContext;
  },

  events: {
    'click [data-refetch-bills-button]': '_fetchBills'
  },

  /**
   * @property criteria {Object} The base criteria for the list of bills to display to the patient.
   *   @property criteria.vecnaIds {String[]} array of vecna ids of the patients to get the bills for.
   */
  criteria: {
    billCriteria: {
      billCriteria: {
        current: true,
        show: true,
        minAccountBalance: 0.01,
        statuses: ['UNPAID']
      }
    },
    isPatient: true,
    vecnaIds: null
  },

  behaviors: {
    bills: {
      behavior: SecureMessageDataBehavior,
      renderOnFetch: true,
      updateEvents: 'viewState:change:criteria behaviors.secureMessage.data:usernameStatusUpdated',
      ids: function() {
        var payableBillsListView = this.view;
        // fetch id protects against multiple simultaneous requests causing view state to revert to an old request.
        var thisFetchId = payableBillsListView._startLoading();

        var criteria = payableBillsListView.criteria;
        return messageService.fetchMessageIdsByCriteria(criteria)
          .then(partialListUtils.convertPartialListResponseToList)
          .always(function() {
            payableBillsListView._completeLoading(thisFetchId);
          });
      }
    }
  },

  prepareFields: {
    payableBillsCount: '_getPayableBillsCount'
  },

  /**
   * @method initialize
   * @param options {Object}
   *   @param options.patientVecnaId {String} the vecna id of the patient that owns the bills in this payable bill list.
   *   @param options.model {PaymentDetailsFormModel} the form model to save any payment info to.
   *                                                  This is copied to model automagically by backbone constructor.
   *   @param options.tableState {TableState} the state & event bus used by the make payment widget.
   *   @param options.billId {Number} the id for a bill item.
   *
   * @override
   */
  initialize: function(options) {
    this._patientVecnaId = options.patientVecnaId;
    this._tableState = options.tableState;
    this.billId = options.billId;
    this.criteria.vecnaIds = [ options.patientVecnaId ];
    var billsBehavior = this.getBehavior('bills');
    var billMessageCollection = billsBehavior.data.privateCollection;
    this.collection = billMessageCollection;
    var paymentDetailsFormModel = this.model;
    paymentDetailsFormModel.setBillMessageCollection(billMessageCollection);
    this.listenTo(billsBehavior, 'fetched', function() {
      paymentDetailsFormModel.payFullByBillId(options.billId);
    });
    this.collection.setSortByType(secureMessageCollection.SORT_TYPE.PAYABLE_BILLS, options.billId);
    this.on('submit', this._submit);
    this.listenTo(billsBehavior, 'change:fetchSuccess', this.render);
  },

  /**
   * A method to fetch unpaid bills.
   * @method _fetchBills
   * @private
   */
  _fetchBills: function() {
    this.getBehavior('bills').fetch();
  },

  /**
   * @method _getPayableBillsCount
   * @returns {Number} the number of payable bills fetched from the server.  returns 0 if none have been fetched.
   * @private
   */
  _getPayableBillsCount: function() {
    var payableBillsCount = this.collection && this.collection.length;
    return payableBillsCount || 0;
  },

  /**
   * @method hasPayableBills
   * @returns {boolean} if the number of payable bills is greater than 0
   */
  hasPayableBills: function() {
    return this._getPayableBillsCount() > 0;
  },

  /**
   * Trigger in-page validation for the current form.
   * @method _submit
   * @private
   */
  _submit: function() {
    _.each(this.getItemViews(), function(itemView) {
      itemView.trigger('submit');
    });
  }
});
